'use client';
import { useEffect } from 'react';
/**
 * Lazy load component to load React Scan from million into the application.
 *
 * @param param0 Component props
 * @param param0.isEnabled whether to enable the plugin or not
 * @returns void
 */
export default function ReactScan({ isEnabled }) {
    // Lazily load react scan to the UI
    useEffect(() => {
        if (!isEnabled) {
            return undefined;
        }
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        import('react-scan').then(({ scan }) => {
            scan({
                enabled: isEnabled,
                trackUnnecessaryRenders: true,
            });
        });
        return void 0;
    }, [isEnabled]);
    return undefined;
}
//# sourceMappingURL=ReactScan.js.map